export default __webpack_public_path__ + "e98e0b41de487f2887e5fb048b39c08e.png";